import { render, staticRenderFns } from "./confBlock.vue?vue&type=template&id=265af3d4"
import script from "./confBlock.vue?vue&type=script&lang=js"
export * from "./confBlock.vue?vue&type=script&lang=js"
import style0 from "./confBlock.vue?vue&type=style&index=0&id=265af3d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports